var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 39.94 38.74"
    },
    xmlSpace: "preserve",
    viewBox: "8.69 9.16 19.11 19.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37158",
    d: "M8.69,21.49v-4.76C8.67,16.05,9,15.4,9.56,15.02c2.5-1.81,5.01-3.62,7.51-5.44  c0.68-0.55,1.65-0.56,2.34-0.01c2.51,1.81,5.02,3.63,7.52,5.45c0.56,0.39,0.89,1.03,0.87,1.72v9.51c0.06,1.06-0.75,1.97-1.82,2.03  c-0.07,0-0.15,0-0.22,0h-3.6c-0.35,0.05-0.68-0.2-0.73-0.55c-0.01-0.06-0.01-0.12,0-0.19v-4.88c0.07-1.05-0.73-1.96-1.78-2.03l0,0  c-0.08-0.01-0.16-0.01-0.25,0h-2.37c-1.05-0.04-1.93,0.79-1.97,1.84l0,0c0,0.04,0,0.09,0,0.13v4.92c0,0.52-0.23,0.76-0.75,0.76h-3.6  c-1.06,0.05-1.96-0.76-2.02-1.82c0-0.06,0-0.12,0-0.19C8.69,24.68,8.69,23.09,8.69,21.49"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCropped);
export default __webpack_public_path__ + "static/media/home-cropped.304542ab7df9d04d9f9aee6090815105.svg";
export { ForwardRef as ReactComponent };